// src/components/Admin/AdminDashboard.js
import React, { useState } from 'react';
import { auth } from '../../firebase';
import ManageAnnouncements from './ManageAnnouncements';
import ManageServices from './ManageServices';
import ManageStaff from './ManageStaff';
import ManageBlogPosts from './ManageBlogPosts';
import ManageTestimonials from './ManageTestimonials';
import ManageGallery from './ManageGallery';

const AdminDashboard = () => {
  const [selectedSection, setSelectedSection] = useState('announcements');

  const handleLogout = () => {
    auth.signOut();
  };

  const renderSection = () => {
    switch(selectedSection){
      case 'announcements':
        return <ManageAnnouncements />;
      case 'services':
        return <ManageServices />;
      case 'staff':
        return <ManageStaff />;
      case 'blogPosts':
        return <ManageBlogPosts />;
      case 'testimonials':
        return <ManageTestimonials />;
      case 'gallery':
        return <ManageGallery />;
      default:
        return <ManageAnnouncements />;
    }
  };

  return (
    <div className="admin-dashboard">
      <h1>管理者ページ</h1>
      <button onClick={handleLogout} className="button logout-button">ログアウト</button>
      <div className="navigation-buttons">
        <button onClick={() => setSelectedSection('announcements')} className={`button ${selectedSection === 'announcements' ? 'active' : ''}`}>お知らせ管理</button>
        <button onClick={() => setSelectedSection('services')} className={`button ${selectedSection === 'services' ? 'active' : ''}`}>サービス管理</button>
        <button onClick={() => setSelectedSection('staff')} className={`button ${selectedSection === 'staff' ? 'active' : ''}`}>スタッフ管理</button>
        <button onClick={() => setSelectedSection('blogPosts')} className={`button ${selectedSection === 'blogPosts' ? 'active' : ''}`}>ブログ投稿管理</button>
        <button onClick={() => setSelectedSection('testimonials')} className={`button ${selectedSection === 'testimonials' ? 'active' : ''}`}>お客様の声管理</button>
        <button onClick={() => setSelectedSection('gallery')} className={`button ${selectedSection === 'gallery' ? 'active' : ''}`}>ギャラリー管理</button>
      </div>
      <div className="selected-section">
        {renderSection()}
      </div>
    </div>
  );
};

export default AdminDashboard;
